export default __webpack_public_path__ + "star-regular-brown.4bc78f67.svg";